import SFetch from '@app/utils/sfetch'
import { CommunicationData } from '@app/application/communication/types'

export default {
  async getCommunication(
    endpointParams: Record<string, string> = {}
  ): Promise<CommunicationData> {
    const url = window.Silverfin.Routes.client_meetings_communications_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId,
      {
        format: 'json',
        past_meetings: endpointParams.pastMeetings,
      }
    )
    return (await SFetch.json(url)) as CommunicationData
  },
  async completeMeeting(
    remarkIds: number[] = [],
    meetingId: number | null = null,
    meetingSummary: string | null = null,
    meetingTitle: string | null = null,
    meetingDate: string | null = null
  ): Promise<void | null> {
    const url = window.Silverfin.Routes.client_meetings_complete_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId,
      { format: 'json' }
    )
    const body = {
      remark_ids: remarkIds,
      meeting_id: meetingId,
      meeting_summary: meetingSummary,
      meeting_title: meetingTitle,
      meeting_date: meetingDate,
    }

    return await SFetch.json(url, {
      method: 'POST',
      body: body,
    })
  },
  async getAISummary(remarkIds: number[] = []): Promise<string | null> {
    const url = window.Silverfin.Routes.client_meetings_ai_summary_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId,
      { format: 'json' }
    )
    const body = {
      remark_ids: remarkIds,
    }

    return await SFetch.json(url, {
      method: 'POST',
      body: body,
    })
  },
  async setOrder(order: number[]): Promise<void> {
    const url = window.Silverfin.Routes.client_meetings_order_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId,
      { format: 'json' }
    )
    await SFetch.json(url, {
      method: 'PUT',
      body: { order },
    })
  },
  async getAISuggestions(): Promise<string[] | null> {
    const url = window.Silverfin.Routes.client_meetings_ai_suggestions_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId,
      { format: 'json' }
    )

    return SFetch.json(url)
  },
  async removeAISuggestion(suggestion: string): Promise<string[] | null> {
    const url =
      window.Silverfin.Routes.client_meetings_remove_ai_suggestion_path(
        window.Silverfin.currentFirmId,
        window.Silverfin.currentCompanyId,
        { format: 'json' }
      )

    return SFetch.json(url, {
      method: 'POST',
      body: { suggestion: suggestion },
    })
  },
}
